"use client";

type SupplyPlanningModule = typeof import("@/app/workspace/SupplyPlanningBlock");
let supplyPlanningPromise: Promise<SupplyPlanningModule> | null = null;

/** Как у flow-table-code-loader: прогрев и React.lazy используют один импорт.
 * Загружается только код. Оболочка и справочники готовятся после выбора
 * магазина, строки и запросы плана ждут sourcesReady отдельно. */
export function loadSupplyPlanningModule(): Promise<SupplyPlanningModule> {
  if (!supplyPlanningPromise) {
    supplyPlanningPromise = import("@/app/workspace/SupplyPlanningBlock").catch(error => {
      supplyPlanningPromise = null;
      throw error;
    });
  }
  return supplyPlanningPromise;
}

export function preloadSupplyPlanningCode(): void {
  void loadSupplyPlanningModule().catch(() => {
    // Ошибка прогрева не блокирует навигацию: React.lazy повторит импорт.
  });
}
